import { buildPositionStyle } from './buildPositionStyle';

/**
 * 构造absolute定位对象
 * @param {*} position
 * @returns
 */
export function positionToStyle(position) {
    const style = buildPositionStyle(position);
    style.position = 'absolute';
    return style;
}
